<button mat-menu-item title="Delete Task Group" [disabled]="deleteClick" (click)="delete()">
  @if (deleteClick) {
    <i class="fa fa-spinner fa-spin"></i>
  }
  <mat-icon aria-hidden="false" aria-label="Delete Task Group">delete</mat-icon>
  <span>Delete Task Group</span>
</button>